import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Dropdown } from 'react-bootstrap'
import { Spinner } from '../../widgets/components/General/Spinner'
import NoDataPage from '../../widgets/components/NoDataPage'
import { DeleteConfirmationModal } from '../../widgets/components/DeleteConfirmationModal'
import { AddInvestorsModal } from './AddInvestorsModal'
import { deleteInvestors, getSingleCompanyInvestors } from '../core/_requests'
import { toast } from 'react-toastify'
import { useShortScale } from '../../../hooks/useShortScale'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'

export const Investors = ({
  getAllCompanyInvestors,
  setSortInvestorsBy,
  setSortInvestorsOrder,
  investorsApiLoading,
  companyInvestorsData,
  companyPageData,
  setLeadInvestors,
  leadInvestors,
  publicStatus,
  publicCompanyPageLoading,
}: {
  getAllCompanyInvestors: any
  setSortInvestorsBy: Dispatch<SetStateAction<string>>
  setSortInvestorsOrder: Dispatch<SetStateAction<string>>
  investorsApiLoading: boolean
  companyInvestorsData: any
  companyPageData: any
  setLeadInvestors: any
  leadInvestors: any
  publicStatus: boolean | undefined
  publicCompanyPageLoading: boolean
}) => {
  const { formatMessage } = useIntl()
  const [isInvestorNameSorted, setIsInvestorNameSorted] = useState(false)
  const [isLeadInvestorsSorted, setIsLeadInvestorsSorted] = useState(false)
  const [isPartnersSorted, setIsPartnersSorted] = useState(false)
  const [isMoneyRaisedSorted, setIsMoneyRaisedSorted] = useState(false)
  const [companyInvestorsId, setCompanyInvestorsId] = useState()
  const [updateModalStatus, setUpdateModalStatus] = useState(false)
  const [showInvestorsModal, setShowInvestorsModal] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const { convertValueToShortScale } = useShortScale()
  const [singleInvestmentData, setSingleInvestorsData] = useState<any>()
  const { currentUser } = useAuth()

  useEffect(() => {
    if (companyInvestorsId) {
      getSingleInvestor()
    }
  }, [companyInvestorsId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getSingleInvestor = async () => {
    try {
      const {
        data: { data, success, errors },
      } = await getSingleCompanyInvestors(companyInvestorsId!)
      if (success) {
        setSingleInvestorsData(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleInvestorsDelete = async (companyInvestorsId: number) => {
    try {
      setDeleteLoading(true)
      if (companyInvestorsId) {
        const {
          data: { success, errors },
        } = await deleteInvestors(companyInvestorsId)
        if (success) {
          setDeleteLoading(false)
          setDeleteShowModal(false)
          getAllCompanyInvestors()
          toast.success(formatMessage({ id: 'Company Investor deleted successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteInvestorsSuccessful,
              action: 'normal',
              metadata: {
                investor_name: singleInvestmentData?.investor_name || '',
                lead_investor: singleInvestmentData?.lead_investor || '',
                money_raised: singleInvestmentData?.money_raised || '',
                partners: singleInvestmentData?.partners || '',
                company_id: singleInvestmentData?.companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        } else {
          setDeleteLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteInvestorsFailed,
              action: 'normal',
              metadata: {
                investor_name: singleInvestmentData?.investor_name || '',
                lead_investor: singleInvestmentData?.lead_investor || '',
                money_raised: singleInvestmentData?.money_raised || '',
                partners: singleInvestmentData?.partners || '',
                company_id: singleInvestmentData?.companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setDeleteLoading(false)
      console.log(err)
    }
  }
  useEffect(() => {
    const leadInvestors = companyInvestorsData?.filter(
      (investor: any) => investor.lead_investor === 'YES'
    )
    setLeadInvestors(leadInvestors)
  }, [companyInvestorsData]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {(publicStatus === false ? investorsApiLoading : publicCompanyPageLoading) ? (
        <Spinner />
      ) : null}
      <div className='card p-7 mt-6 company-page-dark'>
        <div className='d-flex flex-md-row flex-column justify-content-between col-12'>
          <div className='d-flex col-md-7 col-12 justify-content-between gap-md-10 gap-4 flex-md-row flex-column'>
            <div className='col-md-6  bg-clrF3 p-2 px-5 col-12 main-section-dark-bg rounded'>
              <p className='my-2 font-size-13 font-weight-500 text-clr38 main-section-dark-color'>
                {formatMessage({ id: 'Lead Investors' })}
              </p>
              <p className='text-clr58 font-size-16 font-weight-600 dark_text_color'>
                {leadInvestors?.length}
              </p>
            </div>
            <div className='col-md-6  bg-clrF3 p-2 px-5 col-12 main-section-dark-bg rounded'>
              <p className='my-2 font-size-13 font-weight-500 text-clr38 main-section-dark-color'>
                {formatMessage({ id: 'Total Investors' })}
              </p>
              <p className='text-clr58 font-size-16 font-weight-600 dark_text_color'>
                {companyInvestorsData?.length}
              </p>
            </div>
          </div>
          {publicStatus === false && (
            <div className='mt-md-0 mt-4'>
              {/* <BasicButton
                buttonText={formatMessage({id: 'Add Investor'})}
                height='36px'
                width='143px'
                border='none'
                color='#4776E6'
                textColor='#FFFFFF'
                padding='8px 20px'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowInvestorsModal(true)
                }}
              /> */}
              <button
                className='btn bg-primary custom-button-property text-white py-3 w-100'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowInvestorsModal(true)
                }}
              >
                {formatMessage({ id: 'Add Investor' })}
              </button>
            </div>
          )}
        </div>
        {!investorsApiLoading && companyInvestorsData.length === 0 ? (
          <NoDataPage width={`0`} bgTransparent />
        ) : (
          <div>
            <div className='mt-5 text-wrap'>
              {companyInvestorsData?.length > 1 &&
                companyPageData &&
                `${companyPageData?.name} is funded by ${companyInvestorsData?.length} investors. ${companyInvestorsData[companyInvestorsData?.length - 2]?.investor_name
                } and ${companyInvestorsData[companyInvestorsData?.length - 1]?.investor_name
                } are the most recent investors.`}
            </div>
            <div className='table-responsive mt-6'>
              <table className='table table-row-bordered align-middle gs-1 gy-3 mt-0'>
                <thead className='font-size-13'>
                  <tr className='fw-bold text-muted border-bottom-0'>
                    <th className='min-w-200px table-header '>
                      <div
                        className='border border-gray-300  p-3 rounded-1 d-flex justify-content-between cursor-pointer'
                        onClick={() => {
                          setIsInvestorNameSorted(!isInvestorNameSorted)
                          setSortInvestorsBy('investor_name')
                          isInvestorNameSorted
                            ? setSortInvestorsOrder('ASC')
                            : setSortInvestorsOrder('DESC')
                        }}
                      >
                        <span className='font-size-13 fw-semibold text-clr38 font-weight-500 text_clr56'>
                          <img
                            src={toAbsoluteUrl('/media/icons/investor/FilterSymbol.svg')}
                            alt=''
                          />
                          {formatMessage({ id: 'Investor Name' })}
                        </span>
                        <span>
                          {isInvestorNameSorted ? (
                            <img src={toAbsoluteUrl('/media/icons/investor/UpArrow.svg')} alt='' />
                          ) : (
                            <img
                              src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')}
                              alt=''
                            />
                          )}
                        </span>
                      </div>
                    </th>
                    <th className='min-w-200px table-header '>
                      <div
                        className='border border-gray-300 p-3  rounded-1 d-flex justify-content-between cursor-pointer text-clr38 font-weight-500'
                        onClick={() => {
                          setIsLeadInvestorsSorted(!isLeadInvestorsSorted)
                          setSortInvestorsBy('lead_investor')
                          isLeadInvestorsSorted
                            ? setSortInvestorsOrder('ASC')
                            : setSortInvestorsOrder('DESC')
                        }}
                      >
                        <span className='font-size-13 fw-semibold text_clr56'>
                          {formatMessage({ id: 'Lead Investor' })}
                        </span>
                        <span>
                          {isLeadInvestorsSorted ? (
                            <img src={toAbsoluteUrl('/media/icons/investor/UpArrow.svg')} alt='' />
                          ) : (
                            <img
                              src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')}
                              alt=''
                            />
                          )}
                        </span>
                      </div>
                    </th>
                    <th className='min-w-200px table-header '>
                      <div
                        className='border border-gray-300 p-3  rounded-1 d-flex justify-content-between cursor-pointer text-clr38 font-weight-500'
                        onClick={() => {
                          setIsMoneyRaisedSorted(!isMoneyRaisedSorted)
                          setSortInvestorsBy('money_raised')
                          isMoneyRaisedSorted
                            ? setSortInvestorsOrder('ASC')
                            : setSortInvestorsOrder('DESC')
                        }}
                      >
                        <span className='font-size-13 fw-semibold text_clr56'>
                          {formatMessage({ id: 'Money Raised' })}
                        </span>
                        <span>
                          {isMoneyRaisedSorted ? (
                            <img src={toAbsoluteUrl('/media/icons/investor/UpArrow.svg')} alt='' />
                          ) : (
                            <img
                              src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')}
                              alt=''
                            />
                          )}
                        </span>
                      </div>
                    </th>
                    <th className='min-w-200px table-header '>
                      <div
                        className='border border-gray-300  p-3 rounded-1 d-flex justify-content-between cursor-pointer'
                        onClick={() => {
                          setIsPartnersSorted(!isPartnersSorted)
                          setSortInvestorsBy('partners')
                          isPartnersSorted
                            ? setSortInvestorsOrder('ASC')
                            : setSortInvestorsOrder('DESC')
                        }}
                      >
                        <span className='font-size-13 fw-semibold text-clr38 font-weight-500 text_clr56'>
                          {formatMessage({ id: 'Partners' })}
                        </span>
                        <span>
                          {isPartnersSorted ? (
                            <img src={toAbsoluteUrl('/media/icons/investor/UpArrow.svg')} alt='' />
                          ) : (
                            <img
                              src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')}
                              alt=''
                            />
                          )}
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {companyInvestorsData &&
                    companyInvestorsData?.map((investor: any) => (
                      <tr className='fw-normal' key={investor.companyInvestorsId}>
                        <td className='ps-8 form-label'>
                          <span className='ps-3 font-size-12 form-label font-weight-400'>
                            {investor?.investor_name ? investor.investor_name : '-'}
                          </span>
                        </td>
                        <div className='d-block mb-1 table-body font-size-12 form-label font-weight-400'>
                          <span className='ps-3 font-size-12 form-label'>
                            {investor?.lead_investor ? investor.lead_investor : '-'}
                          </span>
                        </div>
                        <td className='table-body ps-8 font-size-12 form-label font-weight-400'>
                          <span className='ps-3 font-size-12 form-label'>
                            {investor?.money_raised
                              ? `$ ${convertValueToShortScale(investor?.money_raised)}`
                              : '-'}
                          </span>
                        </td>
                        <td className='ps-8 d-flex justify-content-between'>
                          <div className='d-block mb-1 table-body font-size-12 form-label font-weight-400'>
                            {investor?.partners ? investor.partners : '-'}
                          </div>
                          {publicStatus === false && (
                            <div>
                              <Dropdown>
                                <div id='remove-investor'>
                                  <Dropdown.Toggle className='bi bi-three-dots-vertical me-1 p-1 px-3 py-2 bg-light text-dark dark_bg_white'></Dropdown.Toggle>
                                </div>
                                <Dropdown.Menu className='m-2'>
                                  <Dropdown.Item className='text-primary'>
                                    <p
                                      className='mb-0'
                                      onClick={() => {
                                        setCompanyInvestorsId(investor.companyInvestorsId)
                                        setUpdateModalStatus(true)
                                        setShowInvestorsModal(true)
                                      }}
                                    >
                                      {formatMessage({ id: 'Edit' })}
                                    </p>
                                  </Dropdown.Item>
                                  <Dropdown.Item className='text-danger'>
                                    <p
                                      className='mb-0'
                                      onClick={() => {
                                        setCompanyInvestorsId(investor.companyInvestorsId)
                                        setDeleteShowModal(true)
                                      }}
                                    >
                                      {formatMessage({ id: 'Delete' })}
                                    </p>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <AddInvestorsModal
        setShowInvestorsModal={setShowInvestorsModal}
        showInvestorsModal={showInvestorsModal}
        companyInvestorsId={companyInvestorsId}
        updateModalStatus={updateModalStatus}
        getAllCompanyInvestors={getAllCompanyInvestors}
      />
      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal}
        setDeleteShowModal={setDeleteShowModal}
        headingMessage={formatMessage({ id: 'Delete Company Investors' })}
        description={formatMessage({ id: 'Are you sure you want to Delete this Company Investors?' })}
        handleDelete={handleInvestorsDelete}
        deleteLoading={deleteLoading}
        id={companyInvestorsId}
      />
    </>
  )
}
